export default __webpack_public_path__ + "public/assets/images/edf7779d099857631c75ab526950fab0.png";